export const SET_CAMPAIGN_DATA = "SET_CAMPAIGN_DATA";
export const SET_SCRAPING_DATA = "SET_SCRAPING_DATA";
